<section *ngIf="showDashboard">
  <div class="wrapper">
    <article class="mrt-75">
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 24px;">
        <h2 style="margin-left: 5px;">Archive Dashboard</h2>
        <div style="display: flex; align-items: center; gap: 16px; margin-right: 10px;">
          <mat-form-field appearance="fill" style="min-width: 120px;">
            <mat-label>Environment</mat-label>
            <mat-select panelClass="um-select-panel" [(value)]="selectedEnv" (selectionChange)="onEnvChange()">
              <mat-option *ngFor="let env of envOptions" [value]="env.value">{{env.label}}</mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>

      <!-- Queue Status -->
      <mat-card style="margin-bottom: 24px;">
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <h3>Queue Status</h3>
          <div style="display: flex; align-items: center; gap: 8px;">
            <button mat-raised-button color="primary" (click)="openQueueDetailsModal()">View Details</button>
            <button mat-icon-button (click)="fetchAllData()" matTooltip="Refresh">
              <mat-icon>refresh</mat-icon>
            </button>
          </div>
        </div>
        <div *ngIf="loadingQueue" style="display:flex;align-items:center;gap:8px;">
          <mat-progress-spinner diameter="22" mode="indeterminate" color="primary" style="margin-right:8px;" [strokeWidth]="4"></mat-progress-spinner>
          Loading queue status...
        </div>
        <div *ngIf="errorQueue" class="error" style="display:flex;align-items:center;gap:8px;"><mat-icon color="warn">error_outline</mat-icon>{{errorQueue}}</div>
        <div *ngIf="queueStatus && !loadingQueue && !errorQueue">
          <div style="display: grid; grid-template-columns: repeat(auto-fit, minmax(200px, 1fr)); gap: 16px; margin-top: 16px;">
            <div style="text-align: center; padding: 16px; background: #f5f5f5; border-radius: 8px;">
              <div style="font-size: 24px; font-weight: bold; color: #1976d2;">{{queueStatus?.queueDetails?.totalQueued || 0}}</div>
              <div style="color: #666;">Total Queued</div>
            </div>
            <div style="text-align: center; padding: 16px; background: #f5f5f5; border-radius: 8px;">
              <div style="font-size: 24px; font-weight: bold; color: #4caf50;">{{queueStatus?.queueDetails?.totalCapacity - queueStatus?.queueDetails?.shortDurationPool?.active - queueStatus?.queueDetails?.longDurationPool?.active || 0}}</div>
              <div style="color: #666;">Available Slots</div>
            </div>
            <div style="text-align: center; padding: 16px; background: #f5f5f5; border-radius: 8px;">
              <div style="font-size: 24px; font-weight: bold; color: #ff9800;">{{queueStatus?.queueDetails?.totalCapacity || 0}}</div>
              <div style="color: #666;">Total Capacity</div>
            </div>
          </div>
        </div>
      </mat-card>

      <!-- Running Jobs Table -->
      <mat-card style="margin-bottom: 24px;">
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <h3>Running Jobs <span *ngIf="runningJobs">({{runningJobs.length}})</span></h3>
          <div style="display: flex; align-items: center; gap: 12px;">
            <mat-form-field appearance="fill" style="min-width: 180px;">
              <mat-label>Filter by Source</mat-label>
              <mat-select panelClass="um-select-panel" [(value)]="selectedRunningSource" (selectionChange)="onRunningSourceChange()">
                <mat-option value="">All</mat-option>
                <mat-option value="Customer Portal">Customer Portal</mat-option>
                <mat-option value="Forensic">Forensic</mat-option>
              </mat-select>
            </mat-form-field>
            <button mat-raised-button color="warn" (click)="confirmCancelAllJobs()" [disabled]="cancelAllLoading" *ngIf="isAdminUser">
              {{ cancelAllLoading ? 'Cancelling...' : 'Cancel All Jobs' }}
            </button>
          </div>
        </div>
        <div *ngIf="cancelAllError" class="error" style="display:flex;align-items:center;gap:8px;"><mat-icon color="warn">error_outline</mat-icon>{{cancelAllError}}</div>
        <div *ngIf="loadingRunning" style="display:flex;align-items:center;gap:8px;">
          <mat-progress-spinner diameter="22" mode="indeterminate" color="primary" style="margin-right:8px;" [strokeWidth]="4"></mat-progress-spinner>
          Loading running jobs...
        </div>
        <div *ngIf="errorRunning" class="error" style="display:flex;align-items:center;gap:8px;"><mat-icon color="warn">error_outline</mat-icon>{{errorRunning}}</div>
        <div *ngIf="runningJobs.length">
          <div class="table-responsive um-table-wrap">
            <table mat-table [dataSource]="runningJobs" class="mat-table um-table" style="width:100%;" matSort (matSortChange)="onRunningSort($event)">
              <ng-container matColumnDef="archiveId">
                <th mat-header-cell *matHeaderCellDef>Archive ID</th>
                <td mat-cell *matCellDef="let job">{{job.archiveId}}</td>
              </ng-container>
              <ng-container matColumnDef="fromDateTime">
                <th mat-header-cell *matHeaderCellDef>From</th>
                <td mat-cell *matCellDef="let job" class="ellipsis-col" [matTooltip]="job.fromDateTime">{{job.fromDateTime}}</td>
              </ng-container>
              <ng-container matColumnDef="toDateTime">
                <th mat-header-cell *matHeaderCellDef>To</th>
                <td mat-cell *matCellDef="let job" class="ellipsis-col" [matTooltip]="job.toDateTime">{{job.toDateTime}}</td>
              </ng-container>
              <ng-container matColumnDef="source">
                <th mat-header-cell *matHeaderCellDef>Source</th>
                <td mat-cell *matCellDef="let job" class="ellipsis-col" [matTooltip]="job.source">{{job.source}}</td>
              </ng-container>
              <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef>User</th>
                <td mat-cell *matCellDef="let job" class="ellipsis-col" [matTooltip]="job.user">{{job.user}}</td>
              </ng-container>
              <ng-container matColumnDef="progressPercent">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Progress</th>
                <td mat-cell *matCellDef="let job">
                  <mat-progress-bar mode="determinate" [value]="job.progressPercent" style="height: 16px; border-radius: 8px;"></mat-progress-bar>
                  <span style="margin-left:8px;">{{job.progressPercent}}%</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="readableProcessingTime">
                <th mat-header-cell *matHeaderCellDef>Proc Time</th>
                <td mat-cell *matCellDef="let job">{{job.readableProcessingTime}}</td>
              </ng-container>
              <ng-container matColumnDef="readableDuration">
                <th mat-header-cell *matHeaderCellDef>Duration</th>
                <td mat-cell *matCellDef="let job">{{job.readableDuration}}</td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let job">{{job.status}}</td>
              </ng-container>
              <ng-container matColumnDef="performance">
                <th mat-header-cell *matHeaderCellDef>Performance</th>
                <td mat-cell *matCellDef="let job">
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <button mat-icon-button 
                            (click)="openPerformanceDialog(job)" 
                            [disabled]="performanceLoading[job.archiveId]"
                            matTooltip="View Performance Details"
                            style="min-width: 32px; height: 32px;">
                      <mat-icon [style.color]="getPerformanceStatusColor(performanceData[job.archiveId])">
                        {{ performanceLoading[job.archiveId] ? 'hourglass_empty' : 'monitor' }}
                      </mat-icon>
                    </button>
                    <span *ngIf="performanceData[job.archiveId]" 
                          [style.color]="getPerformanceStatusColor(performanceData[job.archiveId])"
                          style="font-size: 12px; font-weight: 500;">
                      {{ getPerformanceStatusText(performanceData[job.archiveId]) }}
                    </span>
                  </div>
                  <div *ngIf="performanceError[job.archiveId]" class="error" style="font-size: 11px; margin-top: 4px;">
                    {{ performanceError[job.archiveId] }}
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="poolType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Pool Type</th>
                <td mat-cell *matCellDef="let job">{{job.poolType}}</td>
              </ng-container>
              <ng-container matColumnDef="cameraUniqIdList">
                <th mat-header-cell *matHeaderCellDef>Camera</th>
                <td mat-cell *matCellDef="let job">
                  <ng-container *ngIf="job.cameraUniqIdList && job.cameraUniqIdList.length; else noCams">
                    <a href="#" (click)="openCameraIdsDialog(job.cameraUniqIdList, $event, job.cameraResults, job.status, job.potentialId, job.fromDateTime, job.toDateTime, job.user)">{{job.cameraUniqIdList.length}} cam{{job.cameraUniqIdList.length > 1 ? 's' : ''}}</a>
                  </ng-container>
                  <ng-template #noCams>-</ng-template>
                </td>
              </ng-container>
              <ng-container matColumnDef="potentialId">
                <th mat-header-cell *matHeaderCellDef>Potential</th>
                <td mat-cell *matCellDef="let job">
                  <ng-container *ngIf="job.potentialId; else noPotential">
                    <a *ngIf="job.archiveId.startsWith('HD_')" [href]="'https://nvr.pro-vigil.info/?env=proxy&pId=' + job.potentialId" target="_blank">{{job.potentialId}}</a>
                    <a *ngIf="job.archiveId.startsWith('SD_')" [href]="'https://pro-fit.pro-vigil.com/api/dashboard/sites/details?siteType=&search=' + job.potentialId" target="_blank">{{job.potentialId}}</a>
                    <span *ngIf="!job.archiveId.startsWith('HD_') && !job.archiveId.startsWith('SD_')">{{job.potentialId}}</span>
                  </ng-container>
                  <ng-template #noPotential>-</ng-template>
                </td>
              </ng-container>
              <ng-container matColumnDef="readableRunningTime">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Running Time</th>
                <td mat-cell *matCellDef="let job"><span class="highlight-badge">{{job.readableRunningTime}}</span></td>
              </ng-container>
              <ng-container matColumnDef="readableDuration">
                <th mat-header-cell *matHeaderCellDef>Duration</th>
                <td mat-cell *matCellDef="let job"><span class="highlight-badge">{{job.readableDuration}}</span></td>
              </ng-container>
              <ng-container matColumnDef="siteName">
                <th mat-header-cell *matHeaderCellDef>Site</th>
                <td mat-cell *matCellDef="let job" class="ellipsis-col" [matTooltip]="job.siteName || '-'">{{job.siteName || '-'}}</td>
              </ng-container>
              <ng-container matColumnDef="cancel">
                <th mat-header-cell *matHeaderCellDef>Cancel</th>
                <td mat-cell *matCellDef="let job">
                  <button mat-button color="warn" (click)="confirmCancelJob(job)" [disabled]="cancelJobLoading[job.archiveId]" *ngIf="isAdminUser">
                    {{ cancelJobLoading[job.archiveId] ? 'Cancelling...' : 'Cancel' }}
                  </button>
                  <div *ngIf="cancelJobError[job.archiveId]" class="error">{{cancelJobError[job.archiveId]}}</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="rerun">
                <th mat-header-cell *matHeaderCellDef>Re-run</th>
                <td mat-cell *matCellDef="let job">
                  <button mat-button color="primary" (click)="confirmRerunJob(job)" [disabled]="rerunJobLoading[job.archiveId]" *ngIf="isAdminUser">
                    {{ rerunJobLoading[job.archiveId] ? 'Re-running...' : 'Re-run' }}
                  </button>
                  <div *ngIf="rerunJobError[job.archiveId]" class="error">{{rerunJobError[job.archiveId]}}</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="logs">
                <th mat-header-cell *matHeaderCellDef>Logs</th>
                <td mat-cell *matCellDef="let job">
                  <button mat-button (click)="viewLogs(job.archiveId)">View Logs</button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="runningColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: runningColumns;"></tr>
            </table>
          </div>
        </div>
        <div *ngIf="!loadingRunning && !runningJobs.length && !errorRunning" style="display:flex;align-items:center;gap:8px;color:#888;">
          <mat-icon>info</mat-icon> No running jobs.
        </div>
      </mat-card>
      <mat-divider></mat-divider>

      <!-- Pending Jobs Table -->
      <mat-card style="margin-bottom: 24px;">
        <div style="display: flex; align-items: center; justify-content: space-between;">
          <div style="display: flex; align-items: center; gap: 8px;">
            <h3>Pending Jobs <span *ngIf="pendingJobs">({{pendingJobs.length}})</span></h3>
            <button mat-icon-button (click)="togglePendingJobs()" matTooltip="Toggle visibility">
              <mat-icon>{{ pendingJobsExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
          </div>
          <div style="display: flex; align-items: center; gap: 12px;">
            <mat-form-field appearance="fill" style="min-width: 180px;">
              <mat-label>Filter by Source</mat-label>
              <mat-select panelClass="um-select-panel" [(value)]="selectedPendingSource" (selectionChange)="onPendingSourceChange()">
                <mat-option value="">All</mat-option>
                <mat-option value="Customer Portal">Customer Portal</mat-option>
                <mat-option value="Forensic">Forensic</mat-option>
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div *ngIf="cancelAllPendingError" class="error" style="display:flex;align-items:center;gap:8px;"><mat-icon color="warn">error_outline</mat-icon>{{cancelAllPendingError}}</div>
        <div *ngIf="loadingPending" style="display:flex;align-items:center;gap:8px;">
          <mat-progress-spinner diameter="22" mode="indeterminate" color="primary" style="margin-right:8px;" [strokeWidth]="4"></mat-progress-spinner>
          Loading pending jobs...
        </div>
        <div *ngIf="errorPending" class="error" style="display:flex;align-items:center;gap:8px;"><mat-icon color="warn">error_outline</mat-icon>{{errorPending}}</div>
        <div *ngIf="pendingJobs.length && pendingJobsExpanded">
          <div class="table-responsive um-table-wrap">
            <table mat-table [dataSource]="pendingJobs" class="mat-table um-table" style="width:100%;">
              <ng-container matColumnDef="archiveId">
                <th mat-header-cell *matHeaderCellDef>Archive ID</th>
                <td mat-cell *matCellDef="let job">{{job.archiveId}}</td>
              </ng-container>
              <ng-container matColumnDef="fromDateTime">
                <th mat-header-cell *matHeaderCellDef>From</th>
                <td mat-cell *matCellDef="let job" class="ellipsis-col" [matTooltip]="job.fromDateTime || job.startTime">{{job.fromDateTime || job.startTime}}</td>
              </ng-container>
              <ng-container matColumnDef="toDateTime">
                <th mat-header-cell *matHeaderCellDef>To</th>
                <td mat-cell *matCellDef="let job" class="ellipsis-col" [matTooltip]="job.toDateTime || job.endTime">{{job.toDateTime || job.endTime}}</td>
              </ng-container>
              <ng-container matColumnDef="source">
                <th mat-header-cell *matHeaderCellDef>Source</th>
                <td mat-cell *matCellDef="let job" class="ellipsis-col" [matTooltip]="job.source">{{job.source}}</td>
              </ng-container>
              <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef>User</th>
                <td mat-cell *matCellDef="let job" class="ellipsis-col" [matTooltip]="job.user">{{job.user}}</td>
              </ng-container>
              <ng-container matColumnDef="progressPercent">
                <th mat-header-cell *matHeaderCellDef>Progress</th>
                <td mat-cell *matCellDef="let job">{{job.progressPercent}}%</td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let job">{{job.status}}</td>
              </ng-container>
              <ng-container matColumnDef="performance">
                <th mat-header-cell *matHeaderCellDef>Performance</th>
                <td mat-cell *matCellDef="let job">
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <button mat-icon-button 
                            (click)="openPerformanceDialog(job)" 
                            [disabled]="performanceLoading[job.archiveId]"
                            matTooltip="View Performance Details"
                            style="min-width: 32px; height: 32px;">
                      <mat-icon [style.color]="getPerformanceStatusColor(performanceData[job.archiveId])">
                        {{ performanceLoading[job.archiveId] ? 'hourglass_empty' : 'monitor' }}
                      </mat-icon>
                    </button>
                    <span *ngIf="performanceData[job.archiveId]" 
                          [style.color]="getPerformanceStatusColor(performanceData[job.archiveId])"
                          style="font-size: 12px; font-weight: 500;">
                      {{ getPerformanceStatusText(performanceData[job.archiveId]) }}
                    </span>
                  </div>
                  <div *ngIf="performanceError[job.archiveId]" class="error" style="font-size: 11px; margin-top: 4px;">
                    {{ performanceError[job.archiveId] }}
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="createdDateTime">
                <th mat-header-cell *matHeaderCellDef>Created Date</th>
                <td mat-cell *matCellDef="let job" class="ellipsis-col" [matTooltip]="job.createdDateTime">{{job.createdDateTime}}</td>
              </ng-container>
              <ng-container matColumnDef="cancel">
                <th mat-header-cell *matHeaderCellDef>Cancel</th>
                <td mat-cell *matCellDef="let job">
                  <button mat-button color="warn" (click)="confirmCancelJob(job)" [disabled]="cancelJobLoading[job.archiveId]" *ngIf="isAdminUser">
                    {{ cancelJobLoading[job.archiveId] ? 'Cancelling...' : 'Cancel' }}
                  </button>
                  <div *ngIf="cancelJobError[job.archiveId]" class="error">{{cancelJobError[job.archiveId]}}</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="rerun">
                <th mat-header-cell *matHeaderCellDef>Re-run</th>
                <td mat-cell *matCellDef="let job">
                  <button mat-button color="primary" (click)="confirmRerunJob(job)" [disabled]="rerunJobLoading[job.archiveId]" *ngIf="isAdminUser">
                    {{ rerunJobLoading[job.archiveId] ? 'Re-running...' : 'Re-run' }}
                  </button>
                  <div *ngIf="rerunJobError[job.archiveId]" class="error">{{rerunJobError[job.archiveId]}}</div>
                </td>
              </ng-container>
              <ng-container matColumnDef="logs">
                <th mat-header-cell *matHeaderCellDef>Logs</th>
                <td mat-cell *matCellDef="let job">
                  <button mat-button (click)="viewLogs(job.archiveId)">View Logs</button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="pendingColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: pendingColumns;"></tr>
            </table>
          </div>
        </div>
        <div *ngIf="!loadingPending && !pendingJobs.length && !errorPending" style="display:flex;align-items:center;gap:8px;color:#888;">
          <mat-icon>info</mat-icon> No pending jobs.
        </div>
      </mat-card>
      <mat-divider></mat-divider>

      <!-- All Archives Table -->
      <mat-card>
        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 16px;">
          <h3>All Archives <span *ngIf="totalArchives !== undefined">({{totalArchives}})</span></h3>
          <div style="display: flex; align-items: center; gap: 12px;">
            <mat-form-field appearance="fill" style="min-width: 180px;">
              <mat-label>Filter by Source</mat-label>
              <mat-select panelClass="um-select-panel" [(value)]="selectedArchiveSource" (selectionChange)="onArchiveSourceChange()">
                <mat-option value="">All</mat-option>
                <mat-option value="Customer Portal">Customer Portal</mat-option>
                <mat-option value="Forensic">Forensic</mat-option>
              </mat-select>
            </mat-form-field>
            <mat-checkbox [(ngModel)]="includeDeleted" (change)="onIncludeDeletedChange()" *ngIf="isAdminUser">
              Include Deleted Records
            </mat-checkbox>
          </div>
        </div>
        <div *ngIf="loadingArchives" style="display:flex;align-items:center;gap:8px;">
          <mat-progress-spinner diameter="22" mode="indeterminate" color="primary" style="margin-right:8px;" [strokeWidth]="4"></mat-progress-spinner>
          Loading archives...
        </div>
        <div *ngIf="errorArchives" class="error" style="display:flex;align-items:center;gap:8px;"><mat-icon color="warn">error_outline</mat-icon>{{errorArchives}}</div>
        <div *ngIf="allArchives.length">
          <div class="table-responsive um-table-wrap" style="position:relative;">
            <div *ngIf="loadingArchives" class="table-overlay-spinner">
              <mat-progress-spinner diameter="40" mode="indeterminate" color="primary" [strokeWidth]="5"></mat-progress-spinner>
              <span style="margin-top:12px; color:#1976d2; font-weight:500;">Loading archives...</span>
            </div>
            <table mat-table [dataSource]="allArchives" class="mat-table um-table" style="width:100%;" matSort (matSortChange)="onAllArchivesSort($event)">
              <ng-container matColumnDef="archiveId">
                <th mat-header-cell *matHeaderCellDef class="col-archive-id">Archive ID</th>
                <td mat-cell *matCellDef="let archive" class="col-archive-id">{{archive.archiveId}}</td>
              </ng-container>
              <ng-container matColumnDef="siteName">
                <th mat-header-cell *matHeaderCellDef>Site Name</th>
                <td mat-cell *matCellDef="let archive" class="ellipsis-col" [matTooltip]="archive.siteName || '-'">{{archive.siteName || '-'}}</td>
              </ng-container>
              <ng-container matColumnDef="createdDateTime">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Created</th>
                <td mat-cell *matCellDef="let archive" class="ellipsis-col" [matTooltip]="archive.createdDateTime">{{archive.createdDateTime}}</td>
              </ng-container>
              <ng-container matColumnDef="fromDateTime">
                <th mat-header-cell *matHeaderCellDef>From</th>
                <td mat-cell *matCellDef="let archive" class="ellipsis-col" [matTooltip]="archive.fromDateTime || archive.startTime">{{archive.fromDateTime || archive.startTime}}</td>
              </ng-container>
              <ng-container matColumnDef="toDateTime">
                <th mat-header-cell *matHeaderCellDef>To</th>
                <td mat-cell *matCellDef="let archive" class="ellipsis-col" [matTooltip]="archive.toDateTime || archive.endTime">{{archive.toDateTime || archive.endTime}}</td>
              </ng-container>
              <ng-container matColumnDef="source">
                <th mat-header-cell *matHeaderCellDef>Source</th>
                <td mat-cell *matCellDef="let archive" class="ellipsis-col" [matTooltip]="archive.source">{{archive.source}}</td>
              </ng-container>
              <ng-container matColumnDef="user">
                <th mat-header-cell *matHeaderCellDef>User</th>
                <td mat-cell *matCellDef="let archive" class="ellipsis-col" [matTooltip]="archive.user">{{archive.user}}</td>
              </ng-container>
              <ng-container matColumnDef="progressPercent">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>Progress</th>
                <td mat-cell *matCellDef="let archive">
                  <mat-progress-bar mode="determinate" [value]="archive.progressPercent" style="height: 16px; border-radius: 8px;"></mat-progress-bar>
                  <span style="margin-left:8px;">{{archive.progressPercent}}%</span>
                </td>
              </ng-container>
              <ng-container matColumnDef="fileSizeReadable">
                <th mat-header-cell *matHeaderCellDef class="col-size">Size</th>
                <td mat-cell *matCellDef="let archive" class="col-size">{{archive.fileSizeReadable}}</td>
              </ng-container>
              <ng-container matColumnDef="readableProcessingTime">
                <th mat-header-cell *matHeaderCellDef>Proc Time</th>
                <td mat-cell *matCellDef="let archive">{{archive.readableProcessingTime}}</td>
              </ng-container>
              <ng-container matColumnDef="status">
                <th mat-header-cell *matHeaderCellDef>Status</th>
                <td mat-cell *matCellDef="let archive">{{archive.status}}</td>
              </ng-container>
              <ng-container matColumnDef="performance">
                <th mat-header-cell *matHeaderCellDef>Performance</th>
                <td mat-cell *matCellDef="let archive">
                  <div style="display: flex; align-items: center; gap: 8px;">
                    <button mat-icon-button 
                            (click)="openPerformanceDialog(archive)" 
                            [disabled]="performanceLoading[archive.archiveId]"
                            matTooltip="View Performance Details"
                            style="min-width: 32px; height: 32px;">
                      <mat-icon [style.color]="getPerformanceStatusColor(performanceData[archive.archiveId])">
                        {{ performanceLoading[archive.archiveId] ? 'hourglass_empty' : 'monitor' }}
                      </mat-icon>
                    </button>
                    <span *ngIf="performanceData[archive.archiveId]" 
                          [style.color]="getPerformanceStatusColor(performanceData[archive.archiveId])"
                          style="font-size: 12px; font-weight: 500;">
                      {{ getPerformanceStatusText(performanceData[archive.archiveId]) }}
                    </span>
                  </div>
                  <div *ngIf="performanceError[archive.archiveId]" class="error" style="font-size: 11px; margin-top: 4px;">
                    {{ performanceError[archive.archiveId] }}
                  </div>
                </td>
              </ng-container>
              <ng-container matColumnDef="download">
                <th mat-header-cell *matHeaderCellDef>Download</th>
                <td mat-cell *matCellDef="let archive">
                  <ng-container *ngIf="downloadLink(archive); else noDownload">
                    <span style="display: flex; align-items: center; gap: 1px;">
                      <a [href]="downloadLink(archive)" target="_blank">Download Zip</a>
                      <button mat-icon-button (click)="copyToClipboard(downloadLink(archive))" matTooltip="Copy download link">
                        <mat-icon>content_copy</mat-icon>
                      </button>
                    </span>
                  </ng-container>
                  <ng-template #noDownload>-</ng-template>
                </td>
              </ng-container>
              <ng-container matColumnDef="logs">
                <th mat-header-cell *matHeaderCellDef>Logs</th>
                <td mat-cell *matCellDef="let archive">
                  <button mat-button (click)="viewLogs(archive.archiveId)">View Logs</button>
                </td>
              </ng-container>
              <ng-container matColumnDef="cancel">
                <th mat-header-cell *matHeaderCellDef>Cancel</th>
                <td mat-cell *matCellDef="let archive">
                  <ng-container *ngIf="archive.status === 'Running' || archive.status === 'In-Progress' || archive.status === 'Pending'; else noCancel">
                    <button mat-button color="warn" (click)="confirmCancelJob(archive)" [disabled]="cancelJobLoading[archive.archiveId]" *ngIf="isAdminUser">
                      {{ cancelJobLoading[archive.archiveId] ? 'Cancelling...' : 'Cancel' }}
                    </button>
                    <div *ngIf="cancelJobError[archive.archiveId]" class="error">{{cancelJobError[archive.archiveId]}}</div>
                  </ng-container>
                  <ng-template #noCancel>-</ng-template>
                </td>
              </ng-container>
              <ng-container matColumnDef="rerun">
                <th mat-header-cell *matHeaderCellDef>Re-run</th>
                <td mat-cell *matCellDef="let archive">
                  <ng-container *ngIf="archive.status ; else noRerun">
                    <button mat-button color="primary" (click)="confirmRerunJob(archive)" [disabled]="rerunJobLoading[archive.archiveId]" *ngIf="isAdminUser">
                      {{ rerunJobLoading[archive.archiveId] ? 'Re-running...' : 'Re-run' }}
                    </button>
                    <div *ngIf="rerunJobError[archive.archiveId]" class="error">{{rerunJobError[archive.archiveId]}}</div>
                  </ng-container>
                  <ng-template #noRerun>-</ng-template>
                </td>
              </ng-container>
              <ng-container matColumnDef="potentialId">
                <th mat-header-cell *matHeaderCellDef>Potential</th>
                <td mat-cell *matCellDef="let archive">
                  <ng-container *ngIf="archive.potentialId; else noPotential">
                    <a *ngIf="archive.archiveId.startsWith('HD_')" [href]="'https://nvr.pro-vigil.info/?env=proxy&pId=' + archive.potentialId" target="_blank">{{archive.potentialId}}</a>
                    <a *ngIf="archive.archiveId.startsWith('SD_')" [href]="'https://pro-fit.pro-vigil.com/api/dashboard/sites/details?siteType=&search=' + archive.potentialId" target="_blank">{{archive.potentialId}}</a>
                  </ng-container>
                  <ng-template #noPotential>-</ng-template>
                </td>
              </ng-container>
              <ng-container matColumnDef="cameraUniqIdList">
                <th mat-header-cell *matHeaderCellDef>Camera</th>
                <td mat-cell *matCellDef="let archive">
                  <ng-container *ngIf="archive.cameraUniqIdList && archive.cameraUniqIdList.length; else noCamsArchive">
                    <a href="#" (click)="openCameraIdsDialog(archive.cameraUniqIdList, $event, archive.cameraResults, archive.status, archive.potentialId, archive.fromDateTime, archive.toDateTime, archive.user)">{{archive.cameraUniqIdList.length}} Cam{{archive.cameraUniqIdList.length > 1 ? 's' : ''}}</a>
                  </ng-container>
                  <ng-template #noCamsArchive>-</ng-template>
                </td>
              </ng-container>
              <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef>Delete</th>
                <td mat-cell *matCellDef="let archive">
                  <ng-container *ngIf="archive.status !== 'Running' && archive.status !== 'In-Progress'; else noDelete">
                    <button mat-button color="warn" (click)="confirmDeleteJob(archive)" [disabled]="deleteJobLoading[archive.archiveId]" *ngIf="isAdminUser">
                      {{ deleteJobLoading[archive.archiveId] ? 'Deleting...' : 'Delete' }}
                    </button>
                    <div *ngIf="deleteJobError[archive.archiveId]" class="error">{{deleteJobError[archive.archiveId]}}</div>
                  </ng-container>
                  <ng-template #noDelete>-</ng-template>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <mat-paginator
              [length]="totalArchives"
              [pageIndex]="archivesPageIndex"
              [pageSize]="archivesPageSize"
              [pageSizeOptions]="[10, 20, 50, 100]"
              (page)="onArchivesPage($event)"
              showFirstLastButtons>
            </mat-paginator>
          </div>
        </div>
        <div *ngIf="!loadingArchives && !allArchives.length && !errorArchives" style="display:flex;align-items:center;gap:8px;color:#888;">
          <mat-icon>info</mat-icon> No archives found.
        </div>
      </mat-card>
    </article>
  </div>
</section> 